import ReferenceLocalEvaluator from "../../../../mode/local/ReferenceLocalEvaluator"
import EvaluatorFactory from "../../../../evaluator/EvaluatorFactory"
import { EvaluatorContext } from "../../../../evaluator/Evaluator"
import LocalEvaluateRequest from "../../../../mode/local/LocalEvaluateRequest"
import ExperimentEvaluation from "../../../../service/experiment/ExperimentEvaluation"
import ExperimentLocalEvaluateRequest from "./ExperimentLocalEvaluateRequest"
import { ExperimentConfig } from "../../../../../model/model"

export default class ExperimentReferenceLocalEvaluator extends ReferenceLocalEvaluator<
  ExperimentConfig,
  ExperimentEvaluation
> {
  constructor(private readonly evaluatorFactory: EvaluatorFactory) {
    super()
  }

  protected doEvaluate(
    parentRequest: LocalEvaluateRequest,
    context: EvaluatorContext,
    reference: ExperimentConfig
  ): ExperimentEvaluation {
    const experimentRequest = ExperimentLocalEvaluateRequest.of(
      parentRequest.workspace,
      parentRequest.user,
      reference,
      parentRequest.record
    )
    const evaluator = this.evaluatorFactory.experiment(experimentRequest)
    const response = evaluator.evaluate(experimentRequest, context)
    return response.evaluation
  }
}
